import React from 'react';
import {FormPostDemand} from './sub-view/post-demand';
import {UserLayout} from 'components/layouts/user';

class PostDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active='post-demand'>
        <h1 className="user-header">Chào hàng/Yc báo giá</h1>
        <FormPostDemand/>
      </UserLayout>
    );
  }
}

export default PostDemand;



// WEBPACK FOOTER //
// ./components/users/PostDemand.jsx